// Scroll Animations Handler
// - Element-basierte Animationen
// - Jedes Element mit [data-animate] triggert unabhängig
// - Respektive auch bei langen Sections früh auslösen

export function initScrollAnimations(): void {
	const animatedElements = document.querySelectorAll('[data-animate]') as NodeListOf<HTMLElement>;
	
	if (!animatedElements.length) return;

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) return;

			const element = entry.target as HTMLElement;
			const customDelay = parseFloat(element.getAttribute('data-delay') || '0') * 1000; // in ms
			
			element.style.animationDelay = `${customDelay}ms`;
			element.classList.add('animate-in');

			// Element nach Animation nicht mehr beobachten
			observer.unobserve(element);
		});
	}, {
		threshold: 0.1, // Triggert wenn 10% des Elements sichtbar
	});

	// Alle animierten Elemente beobachten
	animatedElements.forEach(element => {
		observer.observe(element);
	});
}

